module.exports = __webpack_public_path__ + "img/ceo_way_skill_01.b64a19b0.png";